import { render, staticRenderFns } from "./Bdr2026OneCSidebar.vue?vue&type=template&id=49465baa&"
import script from "./Bdr2026OneCSidebar.vue?vue&type=script&lang=js&"
export * from "./Bdr2026OneCSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports